import React, { useEffect, useState } from "react";
import { Reorder, motion } from "framer-motion";
import Wrapper, { wrapperTypes } from "global/wrappers/Wrapper";
import UiSaveButtons from "global/components/buttons/UiSaveButtons";
import { Icon, Label } from "semantic-ui-react";
import _ from "lodash";

const initialIcons = [
  { key: "1", caption: "📅 Schedule" },
  { key: "2", caption: "📊 Stats" },
  { key: "3", caption: "⚙️ Settings" },
  { key: "4", caption: "🧭 Map" },
  { key: "5", caption: "📨 Messages" },
];

const _isInline = true

export default function SortableGrid({
  items,
  showReorder,
  showApply,
  divFn,
  groupKey = 'gk1',
  handleSave
}) {

  const [currentItems, setCurrentItems] = useState(initialIcons);
  const [isSortMode, setIsSortMode] = useState();
  const [allowUpdate, setAllowUpdate] = useState()
  const [draggingKey, setDraggingKey] = useState(null);

  const hasFirstItemLogic = _.some(currentItems, '_isFirstItem');

  useEffect(() => {
    if (items) {
      const _items = _.cloneDeep(items)
      setCurrentItems(_.map(_items, item => item))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items]);

  useEffect(() => {
    setIsSortMode(showReorder)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showReorder]);

  const handleSortUpdate = () => {
    setAllowUpdate(false)
    handleSave(currentItems)
  }

  const handleSetItems = (itemz) => {
    setAllowUpdate(true)
    if (hasFirstItemLogic) {
      const _items = normalizeSections(itemz)
      setCurrentItems(_items)
    } else {
      setCurrentItems(itemz)
    }
  }

  const sortDiv = (item, index) => {
    return <div
      style={{
        margin: '.5em',
        padding: '.5em',
        borderRadius: '4px',
        backgroundColor: 'var(--off-black-2)',
        border: '1px solid var(--off-black-3)',
        display: 'flex',
        columnGap: '1em',
        alignItems: 'center',
        cursor: 'pointer'
      }
      }>
      <Label color={'blue'} size='mini'>{index + 1}</Label>
      <div>
        {item.caption || item.name || item.key}
      </div>
    </div>
  }

  return (
    <div>
      <Wrapper
        wrapperType={wrapperTypes.paddedFooter}
        noMid={true}
        footer={showReorder && showApply && <UiSaveButtons save={{ oc: handleSortUpdate, color: 'blue', caption: 'Apply Changes', icon: 'arrow right', disabled: !allowUpdate }} />}
        content={<Reorder.Group
          key={groupKey}
          as={motion.div}
          axis="y"
          values={currentItems}
          onReorder={handleSetItems}
        >
          {currentItems.map((item, index) => (
            <Reorder.Item
              key={item.key || item._itemKey}
              value={item}
              as={motion.div}
              onDragStart={() => setDraggingKey(item.key)}
              onDragEnd={() => setDraggingKey(null)}
              drag={!item._isFirstItem && isSortMode}
              className={item.key === draggingKey ? 'drg' : ''}
              transition={{ type: 'spring', stiffness: 400, damping: 30 }}
            >
              {item._isFirstItem ? (
                <div className="inhouse" style={{ padding: '.25em', textAlign: 'center' }}>
                  <Icon
                    name="object ungroup outline"
                    color="blue"
                    style={{ marginRight: '1em' }}
                  />
                  {_.startCase(item.propSection)}
                </div>
              ) : (
                divFn ? divFn(item, item.key) : sortDiv(item, index)
              )}
            </Reorder.Item>
          ))}
        </Reorder.Group>}
      >
      </Wrapper >
    </div >
  );
}

const normalizeSections = (items) => {
  // clone if you want to avoid mutating original
  const _items = _.cloneDeep(items);
  _items.forEach((item, index) => {
    assignPropSection(_items, item, index);
  });
  return _items;
};

const assignPropSection = (items, item, index) => {
  // search upwards for the nearest placeholder
  for (let i = index - 1; i >= 0; i--) {
    const candidate = items[i];
    if (candidate._isFirstItem) {
      item.propSection = candidate.propSection;
      break; // stop at the first placeholder above
    }
  }
};

